// extracted by mini-css-extract-plugin
module.exports = {"username-circle":"styles_username-circle__GAbl4","username-text":"styles_username-text__1QLW2"};